export default __webpack_public_path__ + "static/media/info-bg-mobile.26b06d31.png";